import { render } from "./advantage.vue?vue&type=template&id=3294c8d0&scoped=true"
import script from "./advantage.vue?vue&type=script&lang=js"
export * from "./advantage.vue?vue&type=script&lang=js"

import "./advantage.vue?vue&type=style&index=0&id=3294c8d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3294c8d0"

export default script